var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// utils/date.ts
import { parseDate, CalendarDate } from "@internationalized/date";
import { DateTime } from "luxon";
function getSummerBoundsCalendarDates(from = DateTime.now()) {
  const { minDate, maxDate } = summerBounds(from);
  return {
    min: new CalendarDate(minDate.year, minDate.month, minDate.day),
    max: new CalendarDate(maxDate.year, maxDate.month, maxDate.day)
  };
}
__name(getSummerBoundsCalendarDates, "getSummerBoundsCalendarDates");
function calendarRangeStringToCalendarDates(rangeStr) {
  if (!rangeStr) return void 0;
  const [startStr, endStr] = rangeStr.split("/");
  if (!startStr || !endStr) return void 0;
  try {
    return {
      start: parseDate(startStr),
      end: parseDate(endStr)
    };
  } catch {
    return void 0;
  }
}
__name(calendarRangeStringToCalendarDates, "calendarRangeStringToCalendarDates");
function calendarDatesToCalendarRangeString(range) {
  if (!range || !range.start || !range.end) return "";
  const toIso = /* @__PURE__ */ __name((d) => `${d.year.toString().padStart(4, "0")}-${d.month.toString().padStart(2, "0")}-${d.day.toString().padStart(2, "0")}`, "toIso");
  return `${toIso(range.start)}/${toIso(range.end)}`;
}
__name(calendarDatesToCalendarRangeString, "calendarDatesToCalendarRangeString");
function nextJune15(from = DateTime.now()) {
  const j15 = DateTime.fromObject({ year: from.year, month: 6, day: 15 });
  return from > j15 ? j15.plus({ years: 1 }) : j15;
}
__name(nextJune15, "nextJune15");
function nextValidSummerYear(from = DateTime.now()) {
  const j15 = DateTime.fromObject({ year: from.year, month: 6, day: 15 });
  return from > j15 ? from.year + 1 : from.year;
}
__name(nextValidSummerYear, "nextValidSummerYear");
function upcomingSummerYear(from = DateTime.now()) {
  return from.month >= 9 ? from.year + 1 : from.year;
}
__name(upcomingSummerYear, "upcomingSummerYear");
function summerBounds(from = DateTime.now()) {
  const y = nextValidSummerYear(from);
  return {
    minDate: DateTime.fromObject({ year: y, month: 1, day: 1 }),
    maxDate: DateTime.fromObject({ year: y, month: 12, day: 31 }),
    year: y
  };
}
__name(summerBounds, "summerBounds");
function parseSchoolDateRange(rangeStr) {
  if (!rangeStr) return null;
  const [startStr, endStr] = rangeStr.split("/");
  const start = DateTime.fromISO(startStr);
  const end = DateTime.fromISO(endStr);
  if (!start.isValid || !end.isValid) return null;
  return { start, end };
}
__name(parseSchoolDateRange, "parseSchoolDateRange");
function mdyToTimestamp(mdy) {
  const m = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/.exec(mdy.trim());
  if (!m) return null;
  const month = Number(m[1]);
  const day = Number(m[2]);
  const year = Number(m[3]);
  return Date.UTC(year, month - 1, day);
}
__name(mdyToTimestamp, "mdyToTimestamp");
function ageFromCalendarDate(d) {
  if (!d) return "";
  const today = /* @__PURE__ */ new Date();
  let age = today.getFullYear() - d.year;
  const beforeBirthday = today.getMonth() + 1 < d.month || today.getMonth() + 1 === d.month && today.getDate() < d.day;
  if (beforeBirthday) age -= 1;
  if (age < 0 || age > 120) return "";
  return String(age);
}
__name(ageFromCalendarDate, "ageFromCalendarDate");
var isMDY = /* @__PURE__ */ __name((s) => !!s && /^\d{2}\/\d{2}\/\d{4}$/.test(s), "isMDY");
var isISO = /* @__PURE__ */ __name((s) => !!s && /^\d{4}-\d{2}-\d{2}$/.test(s), "isISO");
function mdyToCalendarDate(mdy) {
  if (!mdy || !isMDY(mdy)) return null;
  const [mm, dd, yyyy] = mdy.split("/");
  try {
    return parseDate(`${yyyy}-${mm}-${dd}`);
  } catch {
    return null;
  }
}
__name(mdyToCalendarDate, "mdyToCalendarDate");
function isoToCalendarDate(iso) {
  if (!iso || !isISO(iso)) return null;
  try {
    return parseDate(iso);
  } catch {
    return null;
  }
}
__name(isoToCalendarDate, "isoToCalendarDate");
function anyToCalendarDate(s) {
  if (!s) return null;
  if (isMDY(s)) return mdyToCalendarDate(s);
  if (isISO(s)) return isoToCalendarDate(s);
  return null;
}
__name(anyToCalendarDate, "anyToCalendarDate");
function calendarDateToMDY(val) {
  if (!val) return "";
  const mm = val.month < 10 ? `0${val.month}` : String(val.month);
  const dd = val.day < 10 ? `0${val.day}` : String(val.day);
  const yyyy = String(val.year);
  return `${mm}/${dd}/${yyyy}`;
}
__name(calendarDateToMDY, "calendarDateToMDY");
function computeAgeFromMDY(mdy) {
  const dt = DateTime.fromFormat(mdy, "MM/dd/yyyy");
  if (!dt.isValid) return "";
  const years = Math.floor(DateTime.now().diff(dt, "years").years);
  return years >= 0 ? String(years) : "";
}
__name(computeAgeFromMDY, "computeAgeFromMDY");
export {
  ageFromCalendarDate,
  anyToCalendarDate,
  calendarDateToMDY,
  calendarDatesToCalendarRangeString,
  calendarRangeStringToCalendarDates,
  computeAgeFromMDY,
  getSummerBoundsCalendarDates,
  isISO,
  isMDY,
  isoToCalendarDate,
  mdyToCalendarDate,
  mdyToTimestamp,
  nextJune15,
  nextValidSummerYear,
  parseSchoolDateRange,
  summerBounds,
  upcomingSummerYear
};
